import { ID } from '@datorama/akita';
import { RelationConfig } from '../../models/relation-config.model';

export interface Retirement {
  id: ID;
  person_id: number;
  current: string;
  to_achieve: string;
  from_age: number;
  to_age: number;
  divorce_settlement: string;

  retirement: RelationConfig;
  retirement_configuration_id?: number;
}

export function createRetirement(params: Partial<Retirement>) {
  return {

  } as Retirement;
}
